import React from 'react';
import {
  ModalContainer,
  ModalContent,
  ModalHeader,
  ModalHeaderCustom,
  TextHeaderModal,
  TextHeaderCustom,
  ModalButtonClose,
} from './styles';
import Fechar from '../../../../static/img/fechar.svg';
import Icon from '../../../../components/Section/Icon';
import { CancelIcon } from '../../../../components/Section/Icon/CancelIcon/CancelIcon';

export type ModalProps = {
  header?: string;
  customHeader?: string;
  children: React.ReactNode;
  closeButton?: () => void;
  maxWidth?: string;
  contentWidth?: string;
  contentHeight?: string;
  borderRadius?: string;
  paddingTop?: string;
  padding?: string;
  noHeader?: boolean;
};

export default function Modal({
  header,
  customHeader,
  closeButton,
  children,
  maxWidth,
  contentWidth,
  contentHeight,
  borderRadius,
  paddingTop,
  padding,
  noHeader,
}: ModalProps) {
  return (
    <ModalContainer role="dialog" paddingTop={paddingTop}>
      <ModalContent
        maxWidth={maxWidth}
        contentHeight={contentHeight}
        contentWidth={contentWidth}
        borderRadius={borderRadius}
        padding={padding}
      >
        {!noHeader && header && (
          <ModalHeader>
            <TextHeaderModal>{header}</TextHeaderModal>
            {closeButton && (
              <ModalButtonClose
                type="button"
                aria-label="Fechar diálogo"
                onClick={closeButton}
              >
                <CancelIcon size={{ mobile: 24, desktop: 32 }} />
              </ModalButtonClose>
            )}
          </ModalHeader>
        )}
        {!noHeader && !header && (
          <ModalHeaderCustom>
            <TextHeaderCustom>{customHeader}</TextHeaderCustom>
            {closeButton && (
              <button
                type="button"
                aria-label="Fechar diálogo"
                onClick={closeButton}
              >
                <Icon svg={Fechar} alt="Fechar" />
              </button>
            )}
          </ModalHeaderCustom>
        )}
        {children}
      </ModalContent>
    </ModalContainer>
  );
}
